import { ParameterType } from '@/study-search/enums';

import { Filter } from '../filter/Filter';
export class AllowedFilterCombination {
	public constructor(
		public readonly filterValueCombination: {
			parameterType: ParameterType;
			value?: string;
		}[]
	) {}

	public hasSameParameterTypes(filters: Filter[]): boolean {
		return (
			filters.length === this.filterValueCombination.length &&
			this.filterValueCombination
				.map((parameter) => filters.some((filter) => this.matchesFilterTypeAndValue(filter, parameter)))
				.reduce((previous, next) => previous && next)
		);
	}

	private matchesFilterTypeAndValue(
		filter: Filter,
		parameter: {
			parameterType: ParameterType;
			value?: string;
		}
	): boolean {
		const matchesFilterType = parameter.parameterType === filter.type;
		if (!parameter.value) {
			return matchesFilterType;
		}

		return matchesFilterType && filter.values.length === 1 && filter.values[0] === parameter.value;
	}
}
